export const useAdminTokenStore = defineStore('adminToken', () => {
  const overlayedUserToken = ref('')
  const adminToken = ref('')
  const isConnectedAsUser = ref(false)
  const adminId = ref('')

  function setAdminId(uid: string): void {
    adminId.value = uid
  }

  return {
    overlayedUserToken,
    adminToken,
    isConnectedAsUser,
    adminId,
    setAdminId,
  }
})
